import React from 'react';
import { useBreakpoint } from './BreakpointProvider';
import { radius, space } from '../theme';

// Desktop: frames a DetailHeader (as a TwoPane side panel or in a centred column), rounding its colored band's
// top corners to match the cards around it. It only clips; the header itself is unchanged.
// Phone and tablet: renders the header as is.
const DetailHeaderFrame = ({ children }: { children: React.ReactNode }) => {
  const { isDesktop } = useBreakpoint();
  if (!isDesktop) return <>{children}</>;
  // The bottom padding keeps the overlapping card's shadow inside the clip
  return <div style={{ borderRadius: radius.xl + 4, overflow: 'hidden', paddingBottom: space.md }}>{children}</div>;
};

export default DetailHeaderFrame;
